import React from 'react';
import background from '../../assets/cavendish_bananas.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoBanana extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="LAND"
        description="Cavendish Bananas"
        paragraph="Warming sea surface temperatures are forcing populations of the American lobster (Homarus americanus) to higher latitudes than ever before—and upending fishing communities on the New England coast."
        background={background}
     />
  
  );
 }
}   

export default InfoBanana;